<template>
  <section class="ui-breadcrumb">
    <el-breadcrumb :separator="separator">
      <template v-for="(item, index) in breadList">
        <template v-if="hasTitle(item.meta)">
          <template v-if="item.redirect === fullPath || item.path === fullPath">
            <el-breadcrumb-item :key="index">{{ item.meta.title }}</el-breadcrumb-item>
          </template>
          <template v-else>
            <el-breadcrumb-item :key="index">{{ item.meta.title }}</el-breadcrumb-item>
          </template>
        </template>
      </template>
    </el-breadcrumb>
  </section>
</template>
<script>
import { mapState } from 'vuex'

export default {
  name: 'breadcrumb',
  props: {
    separator: {
      type: String,
      default: '/'
    }
  },
  computed: mapState({
    breadList: (state) => state.breadList,
    fullPath: (state) => state.fullPath
  }),
  methods: {
    hasTitle (item) {
      return !!item.title
    }
  }
}
</script>
<style lang="scss" scoped>
  .el-breadcrumb {
    padding: .15rem .2rem;
  }
</style>
